import { render, staticRenderFns } from "./LanguageDropdown.vue?vue&type=template&id=276015f7"
import script from "./LanguageDropdown.vue?vue&type=script&lang=js"
export * from "./LanguageDropdown.vue?vue&type=script&lang=js"
import style0 from "./LanguageDropdown.vue?vue&type=style&index=0&id=276015f7&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2326903440/src/bitbucket.org/Modis-ito/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('276015f7')) {
      api.createRecord('276015f7', component.options)
    } else {
      api.reload('276015f7', component.options)
    }
    module.hot.accept("./LanguageDropdown.vue?vue&type=template&id=276015f7", function () {
      api.rerender('276015f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/common/components/LanguageDropdown.vue"
export default component.exports